import Skeleton from '@mui/material/Skeleton';
import { useTagById } from 'features/tags';
import React from 'react';
import { useParams } from 'react-router';
import { Tag } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './page-top-bar.style';

export const LoadingTitle: React.FC = () => (
  <Skeleton animation="wave" width="100%" height="1.8rem" />
);

export const Title: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const tag = useTagById(id);

  return tag ? (
    <Styled.TitleContainer>
      <Styled.IllustrationContainer $color={tag.color}>
        <Styled.IconContainer>
          <Icon icon={Tag} />
        </Styled.IconContainer>
      </Styled.IllustrationContainer>

      <Styled.Title>{tag.name}</Styled.Title>
    </Styled.TitleContainer>
  ) : null;
};
